



import './App.css';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Layout from "./pages/Layout";
import Home from "./pages/Home";
import Aurora from './pages/products/Aurora';
import Iceberg from './pages/products/Iceberg';
import Avalanche from './pages/products/Avalanche';
import Netzero from './pages/products/Netzero';
import Visva from './pages/products/Visva';
import One from './pages/products/One';
import SolutionFuelManagement from './pages/solution/FuelManagement';
import ContractorManagement from './pages/solution/ContractorManagement';
import EnvironmentManagement from "./pages/solution/EnvironmentManagement";
import EnterpriceRiskManagement from "./pages/solution/EntepriseRiskManagement";
import RemoteAccessMonitoring from "./pages/solution/RemoteAcessMonitoring";
import SolutionQualityManagement from './pages/solution/QualityManagement';
import VideoAnalyticsPage from './pages/solution/VideoAnalytics';
import OilAndGasPage from './pages/Industries/OilAndGas';
import PowerAndRenewable from './pages/Industries/PowerAndRenewables';
import HealthAndPharma from './pages/Industries/HealthAndPharma';
import EngineeringAndConstruction from './pages/Industries/EngineeringAndConstruction';
import MiningAndMetal from './pages/Industries/MiningAndMetal';
import FoodProcessing from './pages/Industries/FoodProcessing';
import RequestDemo from './pages/RequestDemo';
import { Suspense, useEffect, useState } from 'react';
import LoadingScreen from './pages/LoadingScreen';
import Newsroom from './pages/Newsroom';
import Careers from './pages/Careers';
import About from './pages/About';
import NewsroomDetails from './pages/NewsroomDetails';
import ScrollToTop from './components/ScrollToTop';
import { Unsubscribe } from '@mui/icons-material';
import UnsubscribePage from './pages/UnsubscribPage';
import EmailDemoPage from "./pages/EmailDemoPage";
import PdfViewer from './components/pdfViewer';
import { canUsePerformanceCookies } from "./CookiesHelper";
import axios from 'axios';
import Documentation from './pages/Downloads/Documentation';


function App() {
  const [loading, setLoading] = useState(false);
  const [loadingData, setLoadingData] = useState(null);
  const [dataLoaded, setDataLoaded] = useState(false);

  useEffect(() => {
    const initializeAnalytics = () => {
      if (canUsePerformanceCookies()) {
        loadGoogleAnalytics();
      }
    };

    initializeAnalytics();

    window.addEventListener(
      "cookieConsentUpdated",
      initializeAnalytics
    );

    return () => {
      window.removeEventListener(
        "cookieConsentUpdated",
        initializeAnalytics
      );
    };
  }, []);




  const loadGoogleAnalytics = () => {
    const script = document.createElement("script");
    script.src =
      "https://www.googletagmanager.com/gtag/js?id=G-XXXXXXXX";
    script.async = true;

    document.head.appendChild(script);

    window.dataLayer = window.dataLayer || [];

    function gtag() {
      window.dataLayer.push(arguments);
    }

    gtag("js", new Date());
    gtag("config", "G-XXXXXXXX");
  };

  useEffect(() => {
    getFlashScreenData();
  }, []);

  const getFlashScreenData = async () => {
    try {

      const hasShownLoading = localStorage.getItem(
        "hasShownLoading"
      );

      if (hasShownLoading) {
        return;
      }

      setLoading(true);


      const response = await axios.get(
        "https://dev.ienergydigital.com/task-api/api/cms/entries/?type=flash-screen&status=active"
      );

      const formattedData =
        response.data?.data?.entries?.map((entry) => ({
          id: entry.id,
          status: entry.status,
          text: entry.contentJson?.description,
          type: entry.contentJson?.imageType,
          image: entry.contentJson?.image || "",
          animation_time:
            Number(entry.contentJson?.animationTime) || 3,
        })) || [];

      setLoadingData(formattedData);
      localStorage.setItem(
        "hasShownLoading",
        "true"
      );
      const loadingDuration =
        (formattedData?.[0]?.animation_time) * 1000;

      setTimeout(() => {
        setLoading(false);
      }, loadingDuration);
    } catch (error) {
      console.error(error);
      setLoading(false);
    }
  };


  if (loading) {
    return (
      <LoadingScreen
        loadingData={loadingData}
      />
    );
  }

  return (
    <Router>
      <ScrollToTop />
      <Suspense fallback={<LoadingScreen />}>
        <Routes>
          <Route path="/" element={<Layout />}>
            <Route index element={<Home />} />
            <Route path="/products/netzero" element={<Netzero />} />
            <Route path="/products/iceberg" element={<Iceberg />} />
            <Route path="/products/aurora" element={<Aurora />} />
            <Route path="/products/avalanche" element={<Avalanche />} />
            <Route path="/products/visva" element={<Visva />} />
            <Route path="/products/one" element={<One />} />
            <Route path="/solutions/transport-management" element={<SolutionFuelManagement />} />
            <Route path="/solutions/contractor-management" element={<ContractorManagement />} />
            <Route path="/solutions/environment-intelligence" element={<EnvironmentManagement />} />
            <Route path="/solutions/enterprise-risk-management" element={<EnterpriceRiskManagement />} />
            <Route path="/solutions/remote-access-monitoring" element={<RemoteAccessMonitoring />} />
            <Route path="/solutions/quality-management" element={<SolutionQualityManagement />} />
            <Route path="/solutions/video-analytics" element={<VideoAnalyticsPage />} />
            <Route path="/industries/oil-and-gas" element={<OilAndGasPage />} />
            <Route path="/industries/power-and-renewable" element={<PowerAndRenewable />} />
            <Route path="/industries/mining-and-metals" element={<MiningAndMetal />} />
            <Route path="/industries/engineering-and-construction" element={<EngineeringAndConstruction />} />
            <Route path="/industries/health-and-pharma" element={<HealthAndPharma />} />
            <Route path="/industries/food-processing-industry" element={<FoodProcessing />} />
            <Route path="/request-demo" element={<RequestDemo />} />

            <Route path="/about" element={<About />} />
            <Route path="/careers" element={<Careers />} />
            <Route path="/newsroom" element={<Newsroom />} />
            <Route path="/newsroom-details/:slug" element={<NewsroomDetails />} />
            <Route path="/privacy-policy" element={<PdfViewer />} />
            <Route path="/terms-of-use" element={<PdfViewer />} />
            <Route path ="/documents" element={<Documentation />} />
          </Route>
          <Route path="/demo" element={<EmailDemoPage />} />
          <Route path="/unsubscribe" element={<UnsubscribePage />} />
        </Routes>
      </Suspense>
    </Router>
  );
}

export default App;



